import { useRef } from 'react';
import type { Notification } from '@witmetrics/utils';
import { useToggle } from '@/hooks/useToggle';
import { usePath } from '@/hooks/usePath';
import Menu, { type MenuProps } from '@/components/Menu';
import Title from '@/components/Title';
import { OptionsIcon } from '@/icons';
import NotificationsOptionsMenu from '@/components/NotificationsOptionsMenu';
import NotificationsList from '@/components/NotificationsList';
import { classes } from './utils';

export interface NotificationsMenuProps extends MenuProps {
  notifications: Notification[];
}

export default function NotificationsMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  notifications,
  onClose,
}: NotificationsMenuProps) {
  const menuToggleRef = useRef<HTMLDivElement>(null);
  const { navigate } = usePath();
  const [isOptionsMenuOpen, toggleOptionsMenu] = useToggle(false);

  const handleViewAll = () => {
    navigate('/dashboard/notifications/');
    onClose();
  };

  return (
    <>
      <Menu
        anchorTo={anchorTo}
        open={open}
        className={classes.menu}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={onClose}>
        <div className={classes.header}>
          <Title size="sm">Notifications</Title>
          <div className={classes.buttonsWrapper}>
            <button className={classes.button} onClick={handleViewAll}>
              View all
            </button>
            <div ref={menuToggleRef} className={classes.optionsWrapper}>
              <OptionsIcon
                className={classes.icon}
                onClick={() => toggleOptionsMenu()}
              />
            </div>
          </div>
        </div>
        {notifications.length > 0 ? (
          <NotificationsList
            className={classes.list}
            notifications={notifications}
            onOpen={() => onClose()}
          />
        ) : (
          <div className={classes.emptyMessage}>No notifications</div>
        )}
      </Menu>
      {isOptionsMenuOpen && (
        <NotificationsOptionsMenu
          anchorTo={menuToggleRef.current}
          open={isOptionsMenuOpen}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          onClose={() => toggleOptionsMenu()}
        />
      )}
    </>
  );
}
